<template class="full-heigth">
  <div class="full-heigth" style="padding: 15px">
    <el-form v-if="isAdmin" :inline="true" class="filter-form">
      <el-form-item label="旅行社" style="width: 100%" class="agency-select-item">
        <el-select
          :disabled="isAdmin ? false : true"
          v-model="agencyCode"
          filterable
          placeholder="請選擇旅行社"
          style="width: 100%"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <el-form :inline="true" class="filter-form" style="display: flex">
      <el-form-item label="查詢">
        <el-input
          v-model="listQueryByGroupQuote.search.query"
          placeholder="請輸入旅客名稱/公司名稱/負責業務員"
          style="width: 280px"
          :disabled="!agencyCode"
        />
      </el-form-item>
      <div style="margin: 8px 0 0 8px">
        <el-button
          type="primary"
          icon="el-icon-search"
          circle
          @click="handleSearch"
          :loading="loading"
          :disabled="!agencyCode"
        ></el-button>
        <el-button
          type="success"
          icon="el-icon-refresh-left"
          circle
          @click="handleRefresh"
          :loading="loading"
          :disabled="!agencyCode"
        ></el-button>
        <el-button
          type="warning"
          icon="el-icon-plus"
          circle
          @click="handleCreate"
          :loading="loading"
          :disabled="!agencyCode"
        ></el-button>
      </div>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="loading"
        size="mini"
        :data="listByGroupQuote"
        border
        fit
        highlight-current-row
        height="calc(80vh - 180px)"
        overflow-x="auto"
        :row-class-name="tableRowClassName"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅客填答網址" min-width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleQuestionUrlLink(scope.row.questionUrl, $event)"
            >
              {{ scope.row.signatureStatusDesc }}
              <i class="el-icon-copy-document"></i>
            </el-button>
            <!-- <span>{{ scope.row.questionnaireUrl }}</span> -->
          </template>
        </el-table-column>

        <el-table-column align="center" label="出團名稱" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.contentTitle }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="旅客名稱 / 職稱" min-width="160">
          <template slot-scope="scope">
            <span>
              {{ scope.row.travelerName }}
              {{ scope.row.travelerJob ? ` / ${scope.row.travelerJob}` : '' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="公司名稱" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="聯絡電話" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.tel }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="E-mail" min-width="250">
          <template slot-scope="scope">
            {{ scope.row.email }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="負責業務員" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.saleerName }}
            {{ scope.row.saleerNickName ? ` (${scope.row.saleerNickName})` : '' }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="建立時間" min-width="145">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯報價單" min-width="100">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="handleEditQuote(scope.row)"
              :disabled="!scope.row.travelerName || scope.row.travelerName == ''"
            >
              編輯
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="發送報價單" min-width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleSendQuote(scope.row)"
              :disabled="!scope.row.travelerName || scope.row.travelerName == ''"
            >
              發送
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="報價狀態" min-width="150">
          <template slot-scope="scope">
            <div v-if="!scope.row.status || scope.row.status == statusEnum.WaitReply">等待回覆</div>
            <div v-if="scope.row.status == statusEnum.WaitQuote">已回覆等待報價</div>
            <div v-if="scope.row.status == statusEnum.WaitReplyByQuoteed">已報價等待回覆確認</div>
            <div>
              <el-checkbox
                label="旅客確認報價"
                name="type"
                :value="scope.row.status == statusEnum.Closed"
                @click.native.prevent="handleChangeStatus(scope.row)"
              ></el-checkbox>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="left" label="最後填答時間" min-width="250">
          <template slot-scope="scope">
            {{ scope.row.lastQuestionTime }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="操作" min-width="260">
          <template slot-scope="scope">
            <el-button type="info" size="mini" @click="handleEdit(scope.row)">客戶資料</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">刪除</el-button>
            <el-button type="warning" size="mini" @click="handleCopy(scope.row)">複製</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="listQueryByGroupQuote.total > 0"
        layout="prev, pager, next"
        :total="listQueryByGroupQuote.total"
        :page.sync="listQueryByGroupQuote.page"
        :limit.sync="listQueryByGroupQuote.limit"
        @pagination="handlePagination"
      />
    </div>

    <group-quote-create-or-update-dialog
      :visible.sync="dialogVisibleByGroupQuote"
      :initial-form-data.sync="formDataByGroupQuote"
      :agency-code="agencyCode"
      @save="handleDialogSaveByGroupQuote"
      @closed="handleDialogCloseByGroupQuote"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import checkPermission from '@/utils/permission'
import GroupQuoteCreateOrUpdateDialog from '@/components/Dialog/GroupQuoteCreateOrUpdateDialog.vue'
import {
  copyAgencyTravelGroupQuote,
  deleteAgencyTravelGroupQuote,
  getAgencyOptions,
  getAgencyTravelGroupQuoteForPaged,
  saveAgencyTravelGroupQuote,
  sendAgencyTravelGroupQuoteContentToTraveler,
} from '@/api/agency'
import clipboard from '@/utils/clipboard'

const statusEnum = {
  // 等待回覆
  WaitReply: 0,
  // 已回覆等待報價
  WaitQuote: 1,
  // 已報價等待回覆確認
  WaitReplyByQuoteed: 2,
  // 已確認報價
  Closed: 3,
}

export default {
  name: 'AiFunctionGroupQuote',
  components: {
    Pagination,
    GroupQuoteCreateOrUpdateDialog,
  },
  data() {
    return {
      agencyCode:
        this.$store.getters.userInfo && this.$store.getters.userInfo.agencyCode
          ? this.$store.getters.userInfo.agencyCode
          : null,
      aiLoading: false,
      loading: false,
      listByGroupQuote: [],
      formDataByGroupQuote: {},
      dialogVisibleByGroupQuote: false,
      listQueryByGroupQuote: {
        search: {},
        page: 1,
        limit: 10,
        total: 0,
      },
      agencyList: [],
      isAdmin: checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN']),
      statusEnum,
    }
  },
  async created() {
    await this.getAgencyOptions()
    await this.getGroupQuoteList()
  },
  watch: {
    async loading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
    async aiLoading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showAIProcessLoading', true)
          await this.$store.dispatch(
            'app/showAIProcessLoadingText',
            'AI處理資料中，請不要離開此畫面，感謝您的耐心等候。'
          )
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showAIProcessLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showAIProcessLoading', false)
      }
    },
    async agencyCode(newValue) {
      await this.getGroupQuoteList()
    },
  },
  methods: {
    handleQuestionUrlLink(text, event) {
      clipboard(text, event)
    },
    async handleSearch() {
      await this.getGroupQuoteList()
    },
    async handleRefresh() {
      this.listQueryByGroupQuote = {
        search: {},
        page: 1,
        limit: 10,
        total: 0,
      }

      await this.getGroupQuoteList()
    },
    async handlePagination() {
      await this.getGroupQuoteList()
    },
    async handleCreate() {
      this.formDataByGroupQuote = {}
      this.dialogVisibleByGroupQuote = true
    },
    async handleEdit(data) {
      console.log(data)
      this.formDataByGroupQuote = JSON.parse(JSON.stringify(data))
      this.dialogVisibleByGroupQuote = true
    },
    async handleDelete(data) {
      if (confirm('確定要刪除這筆資料嗎?')) {
        this.loading = true

        await deleteAgencyTravelGroupQuote(data)
          .then(async res => {
            await this.getGroupQuoteList()
            this.$message.success('刪除成功')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async handleEditQuote(data) {
      const quoteWindow = window.open('about:blank', '_blank')
      if (!quoteWindow) {
        this.$message.warning('請允許本站開啟彈出視窗後再試')
        return
      }
      quoteWindow.opener = null
      this.loading = true

      await getAgencyTravelGroupQuoteForPaged({
        agencyCode: this.agencyCode,
        search: {
          id: data.id,
        },
        page: 1,
        limit: 10,
        total: 0,
      })
        .then(res => {
          if (res.success && res.data) {
            const list = res.data.data
            if (list.length > 0) {
              data.contentEditUrl = list[0].contentEditUrl
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })

      if (!quoteWindow.closed) {
        if (data.contentEditUrl) {
          quoteWindow.location.href = data.contentEditUrl
        } else {
          quoteWindow.close()
        }
      }

      if (data.travelerName && !data.contentEditUrl) {
        this.$message.error('報價單生成中，請稍後重整再試')
      }
    },
    async handleCopy(data) {
      if (confirm('確定要複製這筆資料嗎?')) {
        this.loading = true

        await copyAgencyTravelGroupQuote({ id: data.id })
          .then(async () => {
            await this.getGroupQuoteList()
            this.$message.success('複製成功')
          })
          .catch(() => {
            this.$message.error('複製失敗')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async handleSendQuote(data) {
      if (confirm('是否要將此報價單立刻發送至旅客電子郵件?')) {
        this.loading = true

        await sendAgencyTravelGroupQuoteContentToTraveler(data)
          .then(res => {
            data.status = statusEnum.WaitReplyByQuoteed
            this.$message.success('報價單發送成功')
          })
          .catch(err => {
            this.$message.error('報價單發送失敗')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async handleChangeStatus(data) {
      let isChange = false
      if (data.status != statusEnum.Closed) {
        if (confirm('確定旅客已確認報價嗎?')) {
          data.status = statusEnum.Closed
          isChange = true
        }
      } else {
        if (confirm('確定旅客還未確認報價嗎?')) {
          if (data.lastContentId) {
            data.status = statusEnum.WaitReplyByQuoteed
          } else if (data.lastQuestionId) {
            data.status = statusEnum.WaitQuote
          } else {
            data.status = statusEnum.WaitReply
          }
          isChange = true
        }
      }

      if (isChange) {
        this.loading = true
        await saveAgencyTravelGroupQuote(data)
          .then(res => {
            this.$message.success('狀態更新成功')
          })
          .catch(err => {
            console.log(err)
            this.$message.error('狀態更新失敗')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async handleDialogSaveByGroupQuote() {
      this.formDataByGroupQuote = {}
      this.dialogVisibleByGroupQuote = false
      await this.getGroupQuoteList()
    },
    async handleDialogCloseByGroupQuote() {
      this.formDataByGroupQuote = {}
      this.dialogVisibleByGroupQuote = false
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === statusEnum.Closed) {
        return 'close-row'
      }
      return ''
    },
    async getGroupQuoteList() {
      this.loading = true

      await getAgencyTravelGroupQuoteForPaged({
        ...this.listQueryByGroupQuote,
        agencyCode: this.agencyCode,
      })
        .then(res => {
          if (res.success && res.data) {
            this.listByGroupQuote = res.data.data
            this.listQueryByGroupQuote.total = res.data.total
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getAgencyOptions() {
      this.listLoading = true
      await getAgencyOptions()
        .then(response => {
          this.agencyList = response.data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
  },
}
</script>
<style lang="scss">
.el-table .close-row {
  background: #ffaba0;
}

.agency-select-item {
  .el-form-item__content {
    width: 100%;
  }
}
</style>
